module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-114x114-426cf4006511196738fb3c7367528b74.png";